// extracted by mini-css-extract-plugin
export var calendarView = "_fu-0";